// src/components/RemediationSignoffModal.jsx
import { useState, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';

export default function RemediationSignoffModal({ open, onClose, onSave }) {
  const [comment, setComment] = useState('');
  const sigPadRef = useRef(null);

  const handleClear = () => {
    sigPadRef.current?.clear();
  };

  const handleSave = () => {
    if (sigPadRef.current?.isEmpty()) {
      alert('Please provide a signature');
      return;
    }

    const signatureDataUrl = sigPadRef.current.toDataURL();
    onSave({
      signatureUrl: signatureDataUrl,
      comment: comment.trim() || null
    });
    
    handleClear();
    setComment('');
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white text-gray-900 rounded-lg shadow-2xl max-w-2xl w-full mx-4 p-6 border border-gray-200">
        <h2 className="text-xl font-bold mb-4">✔ Sign Off Remediation</h2>
        
        <div className="mb-4">
          <p className="text-sm text-gray-700 mb-3">
            By signing, you confirm that all remediation actions have been reviewed and approved.
            This will lock the report and prevent further modifications.
          </p>
          
          <label className="block text-sm font-medium text-gray-800 mb-2">
            Optional Comment
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Add any final comments (optional)..."
            className="w-full border border-gray-300 rounded p-3 text-sm"
            rows={2}
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-800 mb-2">
            Signature *
          </label>
          <div className="border-2 border-gray-300 rounded bg-white">
            <SignatureCanvas
              ref={sigPadRef}
              canvasProps={{
                className: 'w-full h-40',
                style: { touchAction: 'none' }
              }}
              backgroundColor="white"
            />
          </div>
          <button
            onClick={handleClear}
            className="text-sm text-gray-600 hover:text-gray-800 mt-1"
          >
            Clear Signature
          </button>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 text-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 font-semibold"
          >
            ✔ Sign & Lock Report
          </button>
        </div>
      </div>
    </div>
  );
}
